<template>
  <form @submit.prevent="submit" class="form">
    <Input
      placeholder="С какими площадками работаете?"
      v-model.trim="platforms"
      :error="platformsError"
      @blur="$v.platforms.$touch()"
    />

    <Input
      placeholder="Сколько человек работает с тендарами?"
      v-model.trim="peopleCount"
      :error="peopleCountError"
      @blur="$v.peopleCount.$touch()"
    />

    <Input
      placeholder="Сколько поисковых слов используется?"
      v-model.trim="keywordsCount"
      :error="keywordsCountError"
      @blur="$v.keywordsCount.$touch()"
    />

    <Input
      placeholder="Количество участий за 12 месяцев?"
      v-model.trim="participationsCount"
      :error="participationsCountError"
      @blur="$v.participationsCount.$touch()"
    />

    <Button @click.native="submit" variant="base" class="submit">
      Отправить
    </Button>

    <Checkbox v-model="accepted" :highlight-key="checkboxHighlightKey">
      <span @click.stop
        >Нажимая “Отправить” я соглашаюсь на обработку моих персональных данных
        в соответствии с
        <router-link
          exact
          :to="privacyPolicyPath"
          class="link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Политикой конфиденциальности
        </router-link>
      </span>
    </Checkbox>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Input from "@/components/homePage/Input.vue";
import Button from "@/components/homePage/Button.vue";
import Checkbox from "@/components/homePage/Checkbox.vue";
import { privacyPolicyPath } from "@/router/privacyPolicy";
import api from "@/application";

export default {
  name: "SurveyForm",

  components: {
    Input,
    Button,
    Checkbox,
  },

  data() {
    return {
      platforms: "",
      peopleCount: "",
      keywordsCount: "",
      participationsCount: "",
      accepted: false,
      privacyPolicyPath,
      showErrors: false,
      checkboxHighlightKey: 0,
    };
  },

  validations: {
    platforms: { required },
    peopleCount: { required },
    keywordsCount: { required },
    participationsCount: { required },
  },

  computed: {
    platformsError() {
      if (!this.$v.platforms.$dirty) return "";
      if (!this.$v.platforms.required) return "Поле обязательно для заполнения";
      return "";
    },
    peopleCountError() {
      if (!this.$v.peopleCount.$dirty) return "";
      if (!this.$v.peopleCount.required)
        return "Поле обязательно для заполнения";
      return "";
    },
    keywordsCountError() {
      if (!this.$v.keywordsCount.$dirty) return "";
      if (!this.$v.keywordsCount.required)
        return "Поле обязательно для заполнения";
      return "";
    },
    participationsCountError() {
      if (!this.$v.participationsCount.$dirty) return "";
      if (!this.$v.participationsCount.required)
        return "Поле обязательно для заполнения";
      return "";
    },
    isDisabled() {
      return this.$v.$invalid || !this.accepted;
    },
  },

  methods: {
    async submit() {
      this.$v.$touch();
      this.showErrors = true;

      if (this.$v.$invalid || !this.accepted) {
        if (!this.accepted) this.checkboxHighlightKey++;
        return;
      }

      try {
        await api.mail.sendMessageOnGetToKnowBetter({
          phone: localStorage.getItem("phone"),
          contactName: localStorage.getItem("name"),
          platforms: this.platforms,
          teamSize: this.peopleCount,
          searchKeywords: this.keywordsCount,
          participationCount: this.participationsCount,
        });
        this.platforms = "";
        this.peopleCount = "";
        this.keywordsCount = "";
        this.participationsCount = "";
        localStorage.setItem("phone", "");
        localStorage.setItem("name", "");
        this.$v.$reset();
        this.accepted = false;
        this.$toast.success("Спасибо! Мы свяжемся с Вами в ближайшее время!");
      } catch (e) {
        this.$toast.error(e.message || "Ошибка при отправке формы");
      } finally {
        this.isRequesting = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.form {
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .link {
    color: #a5d8ff;
    text-decoration: none;
  }
  .submit {
    height: 60px;
    background-color: #a5d8ff;
    font-family: Montserrat;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 20px;
    line-height: 1;
    &:disabled {
      background-color: #7b9ab1;
      cursor: not-allowed;
    }
  }
}
</style>
